if (!customElements.get('moztech-purchase-assurance')) {
  class MoztechPurchaseAssurance extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedToProduct) return;

      this.productInfo = this.closest('.product__info-container');
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.variants = this.readVariants();
      this.handleChange = this.handleChange.bind(this);
      this.productInfo?.addEventListener('change', this.handleChange);
      this.isConnectedToProduct = true;
      this.update();
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.handleChange);
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.isConnectedToProduct = false;
    }

    readVariants() {
      const data = this.querySelector('[data-assurance-variants]');

      if (!data) return [];

      try {
        return JSON.parse(data.textContent);
      } catch (error) {
        console.warn('[MOZTECH product assurance] Variant data could not be parsed.', error);
        return [];
      }
    }

    handleChange(event) {
      if (!event.target.matches('input[name="id"], input[type="radio"], select')) return;

      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }

    update() {
      const variantId = Number(this.productForm?.querySelector('input[name="id"]')?.value);
      const variant = this.variants.find((item) => Number(item.id) === variantId);

      if (!variant) return;

      const state = this.getAvailabilityState(variant);
      const status = this.querySelector('[data-assurance-status]');
      const statusLabel = this.querySelector('[data-assurance-status-label]');
      const buttonPrice = this.closest('.product__buy-buttons')?.querySelector('[data-assurance-button-price]');

      if (status) {
        status.classList.remove('is-in-stock', 'is-pre-order', 'is-sold-out');
        status.classList.add(`is-${state.replace('_', '-')}`);
      }

      if (statusLabel) {
        statusLabel.textContent = this.dataset[this.toDatasetKey(`${state}_label`)] || '';
      }

      if (buttonPrice) {
        buttonPrice.textContent = variant.price;
      }
    }

    getAvailabilityState(variant) {
      if (!variant.available) return 'sold_out';

      if (
        variant.inventoryManagement === 'shopify' &&
        variant.inventoryPolicy === 'continue' &&
        Number(variant.inventoryQuantity) <= 0
      ) {
        return 'pre_order';
      }

      return 'in_stock';
    }

    toDatasetKey(value) {
      return value.replace(/_([a-z])/g, (_, character) => character.toUpperCase());
    }
  }

  customElements.define('moztech-purchase-assurance', MoztechPurchaseAssurance);
}
